export const notificationsEn = {
  title: 'Notifications',
  actions: {
    markAllRead: 'Mark all as read',
    markRead: 'Mark as read',
  },
  status: {
    unread: 'New',
  },
  empty: {
    title: 'No notifications',
    description: 'There are no notifications to review right now',
  },
};

export type NotificationsTranslations = typeof notificationsEn;
